var styles = {"box":"BenefitsRow_box_90wvy_1","box-inner":"BenefitsRow_box-inner_90wvy_7","left":"BenefitsRow_left_90wvy_12","right":"BenefitsRow_right_90wvy_17","title":"BenefitsRow_title_90wvy_22","description":"BenefitsRow_description_90wvy_31"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
